import { UIMatch } from "react-router";
import { PulseContext } from "@features/pulse/utils/types";
import { BTSG60PageContext } from "@routes/BTSG60/utils/types";
import { DefaultPageContext } from "@routes/Default/utils/types";
import { HomePageContext } from "@routes/Home/utils/types";
import { LifestyleContext } from "@routes/Section/layouts/Lifestyle/utils/types";
import { BudgetContext } from "@routes/SingaporeBudget/utils/types";
import { SingaporeGePageContext } from "@routes/SingaporeGe/utils/types";
import { RouteParam } from "@typings/Data";
import { Match, MatchResult } from "path-to-regexp";

/**
 * Helper function to get the route match.
 * @param a
 * @param param
 * @returns
 */
export const isMatchResult = (
  urlComponent: Match<RouteParam>,
  param: string
): urlComponent is MatchResult<{ [param]: string }> => {
  return param in (urlComponent as MatchResult<RouteParam>).params;
};

/** Helper function to get the loader data for a given match. We do this to type the loader data properly. */
export const getLoaderData = (match: UIMatch) => {
  switch (match.id) {
    case "routes/Section/layouts/Lifestyle/LifestylePage":
      return match.loaderData as LifestyleContext;

    case "routes/Pulse/PulsePage":
      return match.loaderData as PulseContext;

    case "routes/Home/HomePage":
      return match.loaderData as HomePageContext;

    case "keyword-custom-page-singapore-budget-2024":
    case "keyword-custom-page-singapore-budget-2025":
      return match.loaderData as BudgetContext;

    case "keyword-custom-page-singapore-ge-2025":
      return match.loaderData as SingaporeGePageContext;

    case "routes/BTSG60/BTSG60Page":
      return match.loaderData as BTSG60PageContext;

    default:
      return match.loaderData as DefaultPageContext;
  }
};
